import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './link.component.html',
  styleUrl: './link.component.css',
})
export class LinkComponent {}
